export default "__VITE_ASSET__Uzd4YzKf__"